package us.laantech.laanmanage.feature.reports.department.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import us.laantech.common.dto.company.CompanyBranch
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.api.KtorClient
import us.laantech.routes.pos.reports.z.ZReportDTO
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days


data class DepartmentReportUiState(
    val department: String = "Department Report View",
    val report: ZReportDTO? = null,

    val fromMillis: Long = Clock.System.now().toEpochMilliseconds() - 7.days.inWholeMilliseconds,
    val toMillis: Long = Clock.System.now().toEpochMilliseconds(),

    val branches: List<CompanyBranch> = listOf(),
    val selectedBranch: CompanyBranch? = null,

    val employees: List<EmployeeDTO> = listOf(),
    val selectedEmployee: EmployeeDTO? = null,
    val showFromDatePicker: Boolean = false,
    val showToDatePicker: Boolean = false,
)

class DepartmentReportViewModel(): ViewModel() {

    private val _uiState = MutableStateFlow(DepartmentReportUiState())
    val uiState = _uiState.asStateFlow()
    val ktClient = KtorClient.instance.client

    suspend fun loadEmployees() {
        val response = ktClient.get("/backoffice/employees/list")
        val employees = response.body<List<EmployeeDTO>>()
        println("Loaded employees: ${employees.size}")
        _uiState.update { it.copy(employees = employees) }
    }

    suspend fun loadBranches() {
        val response = ktClient.get("/backoffice/store-management/list")
        val branches = response.body<List<CompanyBranch>>()
        println("Loaded branches: ${branches.size}")
        _uiState.update { it.copy(branches = branches) }
    }

    fun loadReport() {
        viewModelScope.launch {
            val response = ktClient.get("/backoffice/reports/department") {
                contentType(ContentType.Application.Json)
                parameter("from_millis", uiState.value.fromMillis)
                parameter("to_millis", uiState.value.toMillis)
                parameter("branch_uuid", uiState.value.selectedBranch?.uuid)
                parameter("employee_uuid", uiState.value.selectedEmployee?.uuid)
            }
            val report = response.body<ZReportDTO>()
            _uiState.update { it.copy(report = report) }
        }
    }

    // Branch & Employee selection
    fun selectBranch(branch: CompanyBranch?) {
        _uiState.update { it.copy(selectedBranch = branch) }
        viewModelScope.launch { loadReport() }
    }

    fun selectEmployee(employee: EmployeeDTO?) {
        _uiState.update { it.copy(selectedEmployee = employee) }
        viewModelScope.launch { loadReport() }
    }

    // Date Time entry
    fun openFromDatePicker() { _uiState.update { it.copy(showFromDatePicker = true) } }
    fun closeFromDatePicker() { _uiState.update { it.copy(showFromDatePicker = false) } }
    fun openToDatePicker() { _uiState.update { it.copy(showToDatePicker = true) } }
    fun closeToDatePicker() { _uiState.update { it.copy(showToDatePicker = false) } }
    fun updateFromTime(epochMillis: Long) {
        _uiState.update { it.copy(fromMillis = epochMillis) }
        viewModelScope.launch { loadReport() }
    }
    fun updateToTime(epochMillis: Long) {
        _uiState.update { it.copy(toMillis = epochMillis) }
        viewModelScope.launch { loadReport() }
    }



}